interface IFeatureFlag {
	key: string;
	titleKey: string;
	descriptionKey: string;
	defaultValue: boolean;
	svgIcon?: string;
}
export const FeatureFlagsConfig: IFeatureFlag[] = [
	/**
	 * Example:
	 * {
	 * 	key: 'testFlag',
	 * 	titleKey: 'experiments.test.title',
	 * 	descriptionKey: 'experiments.test.description',
	 * 	defaultValue: false,
	 * },
	 */
	{
		key: 'enable-matterport-integration',
		titleKey: 'experiments_section_enable_matterport_title',
		descriptionKey: 'experiments_section_enable_matterport_description',
		defaultValue: false,
	},
	{
		key: 'disable-glb-optimisation',
		titleKey: 'experiments_section_glb_title',
		descriptionKey: 'experiments_section_glb_description',
		defaultValue: false,
	},
	{
		key: 'enable-tiles',
		titleKey: 'experiments_section_ifc_title',
		descriptionKey: 'experiments_section_ifc_description',
		defaultValue: false,
	},
	{
		key: 'enable-culling',
		titleKey: 'experiments_section_culling_title',
		descriptionKey: 'experiments_section_culling_description',
		defaultValue: true,
	},
	{
		key: 'contrast-background',
		titleKey: 'experiments_section_contrast_title',
		descriptionKey: 'experiments_section_contrast_description',
		defaultValue: false,
	},
	{
		key: 'rerank-ai-chat',
		titleKey: 'experiments_section_rerank_title',
		descriptionKey: 'experiments_section_rerank_description',
		defaultValue: false,
	},
	{
		key: 'fragment-threshold',
		titleKey: 'experiments_section_hyper_performance_title',
		descriptionKey: 'experiments_section_hyper_performance_description',
		defaultValue: false,
	},
	{
		key: 'asr',
		titleKey: 'experiments_section_asr_title',
		descriptionKey: 'experiments_section_asr_description',
		defaultValue: false,
	},
	{
		key: 'new-sidebar',
		titleKey: 'experiment_new_right_sidebar',
		defaultValue: false,
		descriptionKey: 'experiment_nrs_description',
	},
	{
		key: 'list-view',
		titleKey: 'experiments_section_list_view_title',
		descriptionKey: 'experiments_section_list_view_description',
		defaultValue: false,
	},
	{
		key: 'aiAssetImageAnalysis',
		titleKey: 'experiments_section_ai_asset_title',
		descriptionKey: 'experiments_section_ai_asset_description',
		defaultValue: false,
	},
	{
		key: 'reports-menu',
		titleKey: 'experiments_section_reports_menu_title',
		descriptionKey: 'experiments_section_reports_menu_description',
		defaultValue: false,
	},
];
